const monthList = [
    { name: null, code: undefined },
    { name: "Jan", code: 1 },
    { name: "Feb", code: 2 },
    { name: "Mar", code: 3 },
    { name: "Apr", code: 4 },
    { name: "May", code: 5 },
    { name: "Jun", code: 6 },
    { name: "Jul", code: 7 },
    { name: "Aug", code: 8 },
    { name: "Sep", code: 9 },
    { name: "Oct", code: 10 },
    { name: "Nov", code: 11 },
    { name: "Dec", code: 12 },
];

export default monthList